import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../services/firebase.config";
import openAIService from "../../services/OpenAIService";

export async function generateIndividualInsights(quizData, displayName) {
  if (!quizData || quizData.length === 0) return {};

  console.log("🔄 Generating individual quiz insights...");

  try {
    const newInsights = {};

    for (const quiz of quizData) {
      try {
        console.log(`🤖 Generating insights for ${quiz.quizType}...`);

        const result = await openAIService.generatePersonalityInsights(
          quiz.results,
          quiz.quizType,
          displayName || "this person"
        );

        newInsights[quiz.quizType] = {
          content: result.insights,
          quizName: quiz.quizName,
          config: quiz.config,
        };

        const quizDocRef = doc(db, "quiz-answers", quiz.quizId);
        await updateDoc(quizDocRef, {
          insights: {
            content: result.insights,
            generated: new Date().toISOString(),
            quizType: quiz.quizType,
          },
        });

        console.log(`✅ Generated and saved insights for ${quiz.quizType}`);
      } catch (err) {
        console.error(
          `❌ Failed to generate insights for ${quiz.quizType}:`,
          err
        );
      }
    }

    return newInsights;
  } catch (err) {
    console.error("Error generating individual insights:", err);
    return {};
  }
}
